import React from "react";
import "../../assets/css/in-game-settings.css";

function BackToDashboardButton({
    onClick,
    label = "Dashboard",
    floating = false,
    centered = false,
    className = ""
}) {
    const classes = [
        "back-to-dashboard-btn",
        floating ? "back-to-dashboard-btn--floating" : "",
        centered ? "back-to-dashboard-btn--centered" : "",
        className
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <button type="button" className={classes} onClick={onClick}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                className="back-to-dashboard-btn__icon"
            >
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
            </svg>
            <span>{label}</span>
        </button>
    );
}

export default BackToDashboardButton;
